export const categories = [
  {
    slug: 'jiating-lunli',
    name: '家庭伦理',
    description: '聚焦家庭内部关系，探讨亲情、婚姻、代际冲突等深刻主题',
    icon: 'ri-home-heart-line',
    color: 'primary',
  },
  {
    slug: 'aiqing-lunli',
    name: '爱情伦理',
    description: '围绕爱情中的道德抉择，展现人性在感情面前的挣扎与成长',
    icon: 'ri-heart-line',
    color: 'accent',
  },
  {
    slug: 'shehui-lunli',
    name: '社会伦理',
    description: '以社会现实为背景，揭示阶层、职场、教育等领域中的伦理困境',
    icon: 'ri-building-line',
    color: 'secondary',
  },
  {
    slug: 'jingdian-lunli',
    name: '经典重温',
    description: '历久弥新的伦理剧佳作，每一部都是时代的记忆与情感的丰碑',
    icon: 'ri-award-line',
    color: 'primary',
  },
  {
    slug: 'guochan-lunli',
    name: '国产伦理',
    description: '中国本土伦理剧精选，贴近生活、反映社会变迁的精品力作',
    icon: 'ri-flag-line',
    color: 'accent',
  },
  {
    slug: 'hanju-lunli',
    name: '韩剧伦理',
    description: '韩国伦理剧推荐，以细腻情感和精良制作著称的家庭剧佳作',
    icon: 'ri-earth-line',
    color: 'secondary',
  },
];

export const categoryColorMap: Record<string, { bg: string; text: string; badge: string }> = {
  primary: { bg: 'bg-primary-100', text: 'text-primary-700', badge: 'bg-primary-500' },
  accent: { bg: 'bg-accent-100', text: 'text-accent-700', badge: 'bg-accent-500' },
  secondary: { bg: 'bg-secondary-100', text: 'text-secondary-700', badge: 'bg-secondary-500' },
};